export const initialState = {
  actionProcessing: false,
  statisticProvider: {
    providers: [],
    details: {
      betCount: {},
      betAmount: {},
      winAmount: {},
      incomeAmount: {},
      commissionBalance: {},
      margin: {},
    },
  },
};
